module.exports = __webpack_public_path__ + "img/5.e60302fe.jpg";